import { connect } from 'react-redux';
import ExecutiveSummaryView from './ExecutiveSummaryView';
import {
  currentClientSelector,
  isAdviserArea,
  selectShowExecutiveSummary,
} from '../CommonSelectors/CommonAreaSelector';
import * as actions from './ExecutiveSummaryActions';
import * as selector from './ExecutiveSummarySelector';

const mapStateToProps = state => ({
  currentClient: currentClientSelector(state),
  isAdviserArea: isAdviserArea(state),
  errors: selector.errorsSelector(state),
  isSavingExecutiveSummary: selector.isSavingExecutiveSummarySelector(state),
  isEditExecutiveSummaryModalOpen: selector.isEditExecutiveSummaryModalOpenSelector(state),
  isDeletingExecutiveSummary: selector.isDeletingExecutiveSummarySelector(state),
  executiveSummaryMessage: selector.executiveSummaryMessageSelector(state),
  showExecutiveSummary: selectShowExecutiveSummary(state),
});

const mapDispatchToProps = {
  openEditExecutiveSummaryModal: actions.openEditExecutiveSummaryModal,
  closeEditExecutiveSummaryModal: actions.closeEditExecutiveSummaryModal,
  saveExecutiveSummary: actions.saveExecutiveSummary,
  deleteExecutiveSummary: clientId => actions.saveExecutiveSummary(clientId, null),
  setErrors: actions.setErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummaryView);
